import { pipe, remoteOption, struct } from '@code-expert/prelude';
import type { TaskId } from '/imports/domain';
import { useCachedQuery } from '/imports/ui/hooks/useProcedure';
import { usePublication } from '/imports/ui/hooks/usePublication';
import type { QuizPageInfo } from './QuizPageInfo';

export interface QuizApi {
  usePageInfo: (taskId: TaskId) => remoteOption.RemoteOption<QuizPageInfo>;
  useTaskNameSubscription: (taskId: TaskId) => remoteOption.RemoteOption<string>;
}

export const quizApi: QuizApi = {
  usePageInfo: (taskId) => useCachedQuery('quizzes.getPageInfo', { props: taskId })[0],

  useTaskNameSubscription: (taskId) =>
    pipe(
      usePublication('tasks.getName', { props: taskId, method: 'findOne' }),
      remoteOption.map(struct.get('name')),
    ),
};
